import { render, staticRenderFns } from "./WinsByAgeRanges.vue?vue&type=template&id=0b91d4ca&scoped=true"
import script from "./WinsByAgeRanges.vue?vue&type=script&lang=js"
export * from "./WinsByAgeRanges.vue?vue&type=script&lang=js"
import style0 from "./WinsByAgeRanges.vue?vue&type=style&index=0&id=0b91d4ca&prod&scoped=true&lang=scss"
import style1 from "./WinsByAgeRanges.vue?vue&type=style&index=1&id=0b91d4ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91d4ca",
  null
  
)

export default component.exports